import Axios from "axios";
import {
  SET_LC_PORT_LIST,
  UNSET_LC_PORT_LIST,
} from "@/store/mutation-types";
import { saveUpdateLcPort, getLcPortList } from "@/store/api";

const state = {
  lcPortList: [],
};

const getters = {
  getLcPortList(state) {
    return state.lcPortList;
  },
};

const mutations = {
  [SET_LC_PORT_LIST](state, data) {
    state.lcPortList = data;
  },
  [UNSET_LC_PORT_LIST](state) {
    state.lcPortList = [];
  },
};

const actions = {
  saveUpdateLcPort({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcPort, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcPortList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcPortList, data)
        .then(function (response) {
          commit("SET_LC_PORT_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LC_PORT_LIST");
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

